;(function (module) {
  'use strict'
  function SmsNotificationController(
    $rootScope,
    $scope,
    $state,
    $http,
    $sce,
    socket,
    socketTransmit,
    socketLogin,
    alertService,
    authService,
    smsStatus,
  ) {
    $scope.groupAlerts = []
    $scope.handleInProgress = false
    //$scope.carouselVisible = false;
    $scope.onCarouselInit = function () {}
    $scope.renderHtml = function (htmlCode) {
      return $sce.trustAsHtml(htmlCode)
    }

    var status = !!$state.params.status ? $state.params.status : 0

    //init of page
    function updateAlerts() {
      alertService.getUnhandledAlerts().then(function (response) {
        var unhandledAlerts = response.data

        //25550624/group-by-multiple-values-underscore-js-but-keep-the-keys-and-values
        var groups = _.groupBy(unhandledAlerts, function (alert) {
          return alert.FromNumber + '#' + alert.FirstName + '#' + alert.LastName
        })

        var grouppedAlerts = _.map(groups, function (group) {
          return {
            handleClicked: false,
            fromNumber: group[0].FromNumber,
            firstName: group[0].Member.FirstName,
            lastName: group[0].Member.LastName,
            email: group[0].Member.AlternateEmail
              ? group[0].Member.AlternateEmail
              : group[0].Member.Email,
            travelerId: group[0].TravelerId,
            organizationName: group[0].Member.Organization.Name,
            conversation: group[0].ChatMessageId,
            topic: group[0].TopicId,
            fromDatabase: false,
            status: smsStatus.Live,
            alerts: _.map(group, function (g) {
              let val
              try {
                val = JSON.parse(g.Message)
                if (typeof val === 'object' || val instanceof Object) {
                  console.log('DEBUG Case 1 ', val)
                  const templateType = val.template_type
                  console.log('DEBUG ==> ', templateType)
                  console.log('DEBUG => ', val)
                  if (templateType === 'generic') {
                    const elements = val.elements
                    return {
                      message: undefined,
                      template: elements.map((m) => {
                        return {
                          title: m.title,
                          subtitle: m.subtitle,
                          image_url: m.image_url,
                        }
                      }),
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in',
                    }
                  } else if (templateType === 'airline_itinerary') {
                    return {
                      message: undefined,
                      template: {
                        intro_message: val.intro_message,
                        pnr_number: val.pnr_number,
                        passenger_info: val.passenger_info[0],
                        flight_info: val.flight_info[0],
                        passenger_segment_info: val.passenger_segment_info[0],
                        total_price: val.total_price,
                        currency: val.currency,
                      },
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in',
                    }
                  } else if (templateType === 'airline_checkin') {
                    return {
                      message: undefined,
                      template: {
                        intro_message: val.intro_message,
                        pnr_number: val.pnr_number,
                        flight_info: val.flight_info[0],
                      },
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in',
                    }
                  } else if (templateType === 'airline_update') {
                    return {
                      message: undefined,
                      template: {
                        intro_message: val.intro_message,
                        pnr_number: val.pnr_number,
                        flight_info: val.update_flight_info,
                      },
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in',
                    }
                  } else if (templateType === 'list') {
                    const elements = val.elements
                    return {
                      message: undefined,
                      template: elements.map((m) => {
                        return {
                          title: m.title,
                          subtitle: m.subtitle,
                        }
                      }),
                      templateType: templateType,
                      time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                      mediaUrl0: g.MediaUrl0,
                      isBot: g.IsBot,
                      direction: 'in',
                    }
                  }
                }
              } catch (e) {
                console.log('DEBUG Case 2', val)
                val = JSON.parse(JSON.stringify(g.Message))
                console.log('DEBUG Case 3', val)
                if (typeof val === 'string' || val instanceof String) {
                  return {
                    message: g.Message,
                    time: moment(g.time).format('MM-DD-YYYY h:mm:ss a'),
                    mediaUrl0: g.MediaUrl0,
                    isBot: g.IsBot ? g.IsBot : false,
                    direction: 'in',
                  }
                }
              }
            }),

            topic: group[0].TopicId,
            channel: group[0].Channel,
          }
        })

        $scope.groupAlerts = grouppedAlerts
      })
    }

    if (status === 0) {
      updateAlerts()
    }

    setTimeout(function () {
      if (
        navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.appVersion.indexOf('Trident/') > 0
      ) {
        var evt = document.createEvent('UIEvents')
        evt.initUIEvent('resize', true, false, window, 0)
        window.dispatchEvent(evt)
      } else {
        window.dispatchEvent(new Event('resize'))
      }
    }, 2000)

    //on socket event
    $scope.$on('updateAlerts', function (event, data) {
      console.log('updateAlerts')
      updateAlerts()
    })

    //init of page

    //on user's action
    $scope.handleAlert = function (alert) {
      //fromNumber, firstName, lastName) {
      $scope.handleInProgress = true
      console.log(alert)
      console.log($scope.groupAlerts)
      const loginMember = authService.getLoginMember()
      const status = !!alert.status ? alert.status : smsStatus.Live
      const handleData = {
        fromNumber: alert.fromNumber,
        socketId: socketLogin.getSocketId(),
        travelAgencyId: loginMember.Organization.Id,
        travelAgencyName: loginMember.Organization.Name,
        travelAgentFirstName: loginMember.FirstName,
        travelAgentLastName: loginMember.LastName,
        travelAgentEmail: loginMember.Email,
        travelAgentId: loginMember.Id,
        topic: alert.topic,
        travelerFirstName: alert.firstName,
        travelerLastName: alert.lastName,
        travelerOrganizationName: alert.organizationName,
        conversation: alert.conversation,
        fromDatabase: alert.fromDatabase,
        transferByAgentEmail: alert.transferByAgentEmail
          ? alert.transferByAgentEmail
          : null,
        status: status,
        channel: alert.channel,
        firstTimeHandle: true,
        travelerId: alert.travelerId,
      }

      $rootScope.$broadcast('smsHandle', handleData)
      if ($state.current.name !== 'app.sms') {
        $http.post('/handleConversation', handleData).then((response) => {
          $state.go('app.sms', {
            fromNumber: alert.fromNumber,
            travelerFirstName: alert.firstName,
            travelerLastName: alert.lastName,
            travelerOrganizationName: alert.organizationName,
            travelerId: alert.travelerId,
            topic: alert.topic,
            fromDatabase: false,
            conversation: alert.conversation,
            status: status,
            channel: alert.channel,
          })
          setTimeout(() => {
            $scope.handleInProgress = false
          }, 5000)
        })
      } else {
        $state.go(
          $state.current,
          {},
          {
            reload: true,
          },
        )
      }
    }
  }

  module.controller('SmsNotificationController', [
    '$rootScope',
    '$scope',
    '$state',
    '$http',
    '$sce',
    'socket',
    'socketTransmit',
    'socketLogin',
    'alertService',
    'authService',
    'smsStatus',
    SmsNotificationController,
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/smsNotificationController.js